<template>
  <v-container class="text-center">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="subtitle-1 text-center" cols="12">
        <ServiceTitle :size="2"></ServiceTitle>
        <p class="h1">{{ message }}</p>
        <v-btn @click="proceed" v-if="first">次へ</v-btn>
      </v-col>
      <v-col cols="5">
        <v-progress-linear
          :color="loading ? 'orange lighten-1' : 'transparent'"
          indeterminate
          rounded
          height="6"
          v-if="loading"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row
      ><v-col>
        <p v-if="failed">
          <router-link to="login">戻る</router-link>
        </p>
        <!-- <p v-else-if="loadingError">
          <router-link to="top">スキップ</router-link>
        </p> -->
      </v-col></v-row
    >
    {{ errorMessge }}
  </v-container>
</template>

<script>
import evernote from '@/services/EvernoteService'
import ServiceTitle from '@/components/ServiceTitle.vue'
import indexedDB from '@/services/IndexedDBService'

export default {
  components: {
    ServiceTitle
  },
  data() {
    return {
      message: '認証に成功しました',
      errorMessge: '',
      first: true,
      failed: false,
      loading: false,
      loadingError: false
    }
  },
  computed: {
    isCancelled: vm => vm.$route.query.reason === 'cancelled'
  },
  // 2021-01-27 PC-chomeではなぜか2回呼ばれている → mounted廃止
  // async mounted() {
  methods: {
    async proceed() {
      this.first = false
      if (this.isCancelled) {
        this.message = 'キャンセルされました'
        this.failed = true
      } else {
        evernote.loggedInBefore = true

        // console.log('processing...', this.$route.query)
        this.message = 'トークン取得中...'
        const data = await evernote.callback(
          this.$route.query.oauth_token,
          this.$route.query.oauth_verifier,
          evernote.getTemporaryToken()
        )
        if (data.succeeded) {
          evernote.isLoggedIn = true

          if (this.$matomo) {
            this.$matomo.trackEvent('Callback', 'Loggedin')
          }

          this.message = 'ノートブックとタグ読み込み中...'
          // evernote.sessionId = data.sessionId  // to_be_removed
          this.loading = true
          // その他
          evernote.initInfo()
          // ノートとタグ
          indexedDB.setup().then(() => {
            // console.log(data)
            evernote.reloadNotebooksAndTags().then(results => {
              this.loading = false
              if (results[0].succeeded && results[1].succeeded) {
                this.$router.push({ path: '/' })
              } else {
                this.message = 'エラーが起きました。' //ノートブックとタグを後で読み込んでください。'
                this.loadingError = true
              }
            })
          })
        } else {
          this.message = 'エラーが起きました。しばらくしてから試してください。'
          this.failed = true
          if (data.message) {
            console.log(data.message)
          }
        }
        evernote.removeTemporaryToken()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
